import { UniversalImageElement } from './image/image';
import DateElement from './date/date';

export default {
    'div-image-element': UniversalImageElement,
    'date_element': DateElement
};